
import { createClient } from '@supabase/supabase-js';

// Fallback values for development/testing if process.env is not populated
// IMPORTANT: For production, make sure these are set in your Vercel/CI environment variables.
const fallbackUrl = 'https://wwtjhvmztwzzpggzbdqu.supabase.co';
const fallbackKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3dGpodm16dHd6enBnZ3piZHF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0MTA1NjYsImV4cCI6MjA4NDk4NjU2Nn0.yU-5--fDC1kRB7chbno6c9sFP1RhcPXcSQDpjuUWRDA';

const supabaseUrl = process.env.SUPABASE_URL || fallbackUrl;
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY || fallbackKey;

if (!process.env.SUPABASE_URL) {
  console.warn("SUPABASE_URL not found in process.env. Using fallback URL. Storage may fail if this URL doesn't match your project.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});
